import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { Input, Label } from "arv-reactcomponents";
import DeliveryOptionDetails from "./DeliverOptionDetails";
import { Checkout } from "npmlinks-constants";
import StoreListModal from "../../StoreListModal";
import { getStrippedCart } from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("CheckoutStore", "AddressStore")
@observer
class DeliveryOptions extends Component {
  static triggerGaEventForDeliveryUpdate(method) {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_DELIVERY_METHOD_UPDATE,
      label: method,
    });
  }
  static triggerGaEventForCollectFromStoreClick() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_COLLECTFROMSTORE_CLICK,
    });
  }
  static triggerGaEventForStoreSelected() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_STORE_SELECTED,
    });
  }
  constructor() {
    super();
    this.state = {
      isStoreModalOpen: false,
      storesLoading: false,
    };
    this.openStoresModal = this.openStoresModal.bind(this);
    this.closeStoresModal = this.closeStoresModal.bind(this);
    this.deliveryUpdate = this.deliveryUpdate.bind(this);
    this.isOptionSelected = this.isOptionSelected.bind(this);
    this.selectStore = this.selectStore.bind(this);
  }
  get deliveryToShow() {
    const { product } = this.props;
    const [standDelivery] = product.deliveryDetails.filter(
      option =>
        option.deliveryType === Checkout.CHECKOUT_DELIVERY_OPTIONS.STANDARD,
    );
    const [selectedDelivery] = product.deliveryDetails.filter(
      option => option.deliveryType === product.shippingMethod,
    );
    const deliveryToShow = selectedDelivery || standDelivery || null;
    return (deliveryToShow && [deliveryToShow]) || [];
  }
  get storeOptions() {
    const { product } = this.props;
    const storeOptions = [];
    if (product.storeCount > 0) {
      const storeObj = {
        deliveryType: Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK,
        header: "Collect From Store",
      };
      storeOptions.push(storeObj);
    }
    return storeOptions;
  }
  get deliveryOptions() {
    return [...this.deliveryToShow, ...this.storeOptions];
  }
  get currentPincode() {
    const { pincode = "" } = this.props.CheckoutStore;
    return pincode;
  }
  get currentStores() {
    const { storeList } = this.props.CheckoutStore;
    const { product } = this.props;
    const currentStoreList = storeList.find(
      item => item.skuId === product.skuId,
    );
    return (currentStoreList && currentStoreList.stores) || [];
  }
  isOptionSelected(option) {
    const { product } = this.props;
    return product.shippingMethod === option.deliveryType;
  }
  openStoresModal() {
    DeliveryOptions.triggerGaEventForCollectFromStoreClick();
    this.setState({ isStoreModalOpen: true, storesLoading: true });
    const strippedCart = getStrippedCart(this.props.CheckoutStore.cartItems);
    const modifiedRequestForStoreCall = strippedCart.map(item => ({
      skuId: item.skuId,
      quantity: item.qty,
    }));
    const body = {
      pincode: this.currentPincode,
      skus: modifiedRequestForStoreCall,
    };
    this.props.CheckoutStore.getStores(body).then(() => {
      this.setState({ storesLoading: false });
    });
  }
  closeStoresModal() {
    this.setState({ isStoreModalOpen: false, storesLoading: false });
  }
  deliveryUpdate(option) {
    if (option.deliveryType === Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK) {
      this.openStoresModal();
    } else {
      DeliveryOptions.triggerGaEventForDeliveryUpdate(option.deliveryType);
      const requestBody = Object.assign({}, Checkout.CHECKOUT_BASE_REQUEST);
      const { product } = this.props;
      const [productForRequest] = getStrippedCart([product]);
      const deliverUpdateObj = {
        shippingMethod: option.deliveryType,
      };
      requestBody.type = Checkout.CHECKOUT_API_ACTIONS.UPDATE;
      requestBody.selectedShippingMethods = [
        Object.assign(productForRequest, deliverUpdateObj),
      ];
      this.props.CheckoutStore.updateCart(requestBody).then(() => {
        console.log("delivery option updates");
      });
    }
  }

  selectStore(store) {
    this.setState({ storesLoading: true });
    const requestBody = Object.assign({}, Checkout.CHECKOUT_BASE_REQUEST);
    const { product } = this.props;
    const [productForRequest] = getStrippedCart([product]);
    const storeUpdateObj = {
      shippingMethod: Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK,
      storeId: store.fcId,
    };
    requestBody.type = Checkout.CHECKOUT_API_ACTIONS.UPDATE;
    requestBody.selectedShippingMethods = [
      Object.assign(productForRequest, storeUpdateObj),
    ];
    this.props.CheckoutStore.updateCart(requestBody).then(() => {
      DeliveryOptions.triggerGaEventForStoreSelected();
      this.closeStoresModal();
    });
  }

  render() {
    const { product } = this.props;
    const { isStoreModalOpen, storesLoading } = this.state;
    return (
      <div className="nw-checkoutpage-deloptions-container">
        <ul className="nw-checkoutpage-deloptions-ul">
          {this.deliveryOptions.map((option, index) => (
            <li
              className="nw-checkoutpage-deloptions-items"
              key={option.deliveryType}
            >
              <Label
                className="nw-checkoutpage-deloptions-label"
                htmlFor={`nw-checkoutpage-deloptions-${product.skuId}-${
                  option.deliveryType
                }`}
              >
                <Input
                  id={`nw-checkoutpage-deloptions-${product.skuId}-${
                    option.deliveryType
                  }`}
                  type="radio"
                  value={index}
                  className="nwc-inp-radio-primary nwc-inp-xs"
                  checked={this.isOptionSelected(option)}
                  name={`${product.skuId}-${option.deliveryType}`}
                  onChange={() => this.deliveryUpdate(option)}
                />

                <div className="nw-checkoutpage-deloptions-name">
                  {option.header}
                </div>
              </Label>
              <DeliveryOptionDetails.component
                product={product}
                deliveryShown={this.deliveryToShow}
                option={option}
                deliveryUpdate={this.deliveryUpdate}
                openStoresModal={this.openStoresModal}
              />
            </li>
          ))}
        </ul>
        <StoreListModal.component
          data={this.currentStores}
          isOpen={isStoreModalOpen}
          onClose={this.closeStoresModal}
          loading={storesLoading}
          selectStore={this.selectStore}
          pincode={this.currentPincode}
        />
      </div>
    );
  }
}

DeliveryOptions.wrappedComponent.propTypes = {
  product: PropTypes.shape({}).isRequired,
  CheckoutStore: PropTypes.shape({
    pincode: PropTypes.string.isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    getStores: PropTypes.func.isRequired,
    updateCart: PropTypes.func.isRequired,
    storeList: PropTypes.shape({}).isRequired,
  }).isRequired,
  AddressStore: PropTypes.shape({
    currentPincode: PropTypes.string.isRequired,
  }).isRequired,
};

export { default as DeliverOptionDetails } from "./DeliverOptionDetails";

const getFinalComponent = component =>
  inject("CheckoutStore", "AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: DeliveryOptions.wrappedComponent,
  component: DeliveryOptions,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/DeliveryOptions/index.js